export const boxShadow = () => `
  box-shadow:
    rgba(0, 0, 0, 0.117647) 0px 1px 6px,
    rgba(0, 0, 0, 0.117647) 0px 1px 4px;
`;

export const gridGapSize = 16;



// WEBPACK FOOTER //
// ./src/lib/styles/helpers.js